module.exports = __webpack_public_path__ + "static/media/m15.6643a62e.png";